import { apiClient } from './client';
import {
  ProjectsResponse,
  CreateProjectRequest,
  UpdateProjectRequest,
  Project,
  APIResponse,
} from '../types/api';

export const projectsAPI = {
  // Get all user projects
  getProjects: async (): Promise<ProjectsResponse> => {
    return apiClient.get('/projects');
  },

  // Get a specific project
  getProject: async (projectId: string): Promise<APIResponse<Project>> => {
    return apiClient.get(`/projects/${projectId}`);
  },

  // Create a new project
  createProject: async (data: CreateProjectRequest): Promise<APIResponse<Project>> => {
    return apiClient.post('/projects', data);
  },

  // Update an existing project
  updateProject: async (
    projectId: string,
    data: UpdateProjectRequest
  ): Promise<APIResponse<Project>> => {
    return apiClient.put(`/projects/${projectId}`, data);
  },

  // Delete a project
  deleteProject: async (projectId: string): Promise<APIResponse> => {
    return apiClient.delete(`/projects/${projectId}`);
  },
};